import * as React from 'react';
import { haveLoginData } from 'views/job-costing/utils/CostAndRevenueHelpers';
import authentication from 'containers/authorization/authentication';
import { ModalMain } from 'damco-components';

interface IProps {
    nickname: any
}
export const UserDataControl = (props:IProps) => {
    const shouldDisplay = !haveLoginData(props.nickname);
    const closeDialog = () =>{
       authentication.signOut();
    }
    if(shouldDisplay){
        return(
            <ModalMain 
                modal={shouldDisplay} 
                title={'User token expired'} 
                hideMethod={ () => closeDialog } 
                secondaryMethod={ () => closeDialog} 
                primaryMethod={()=> closeDialog} btnTitle1={'OK'} btnTitle2={'CLOSE'}>
                Your login data has expired, you will be logged out
            </ModalMain>
        )
    }else{
        return <div/>
    }
}